/*
 * Copyright (c) 2022 CalAmp Corp.  All Rights Reserved
 */
import {createDeepEqualSelector} from '@ion/applications/src/store/selectors/SelectorUtils';

const selectGlobalGroup = ({
  globalGroup: {
    accountHierarchy,
    globalGroup
  }
}) => ({
  accountHierarchy,
  globalGroup
});

const selectGlobalSearch = ({
  globalSearch: {
    searchKeyword,
    searchModule,
    search : {
      isViewing: open
    }
  }
}) => ({
  searchKeyword,
  searchModule,
  search : {
    isViewing : open
  }
});

export const globalGroupSelector = createDeepEqualSelector([
  selectGlobalGroup
], ({
  accountHierarchy,
  globalGroup
}) => ({
  accountHierarchy,
  globalGroup
}));

export const globalSearchSelector = createDeepEqualSelector([
  selectGlobalSearch
], ({
  searchKeyword,
  searchModule,
  search : {
    isViewing : open
  }
}) => ({
  searchKeyword,
  searchModule,
  search : {
    isViewing : open
  }
}));
